/* Harmony Modern: pinch / scroll / double-click zoom for the product lightbox */
(function () {
  var MAX = 4, MIN = 1, STEP = 2.5;
  var st = new WeakMap();
  function S(img) { var s = st.get(img); if (!s) { s = { s: 1, x: 0, y: 0 }; st.set(img, s); } return s; }
  function apply(img, anim) {
    var s = S(img);
    var w = img.clientWidth, h = img.clientHeight;
    s.x = Math.min(0, Math.max(w * (1 - s.s), s.x));
    s.y = Math.min(0, Math.max(h * (1 - s.s), s.y));
    img.style.transformOrigin = '0 0';
    img.style.transition = anim ? 'transform .25s ease' : 'none';
    img.style.transform = s.s === 1 ? '' : 'translate(' + s.x + 'px,' + s.y + 'px) scale(' + s.s + ')';
    img.style.cursor = s.s > 1 ? 'grab' : 'zoom-in';
    var stage = img.closest('.lightbox__stage'); if (stage) stage.classList.toggle('hm-zoomed', s.s > 1);
  }
  function zoomAt(img, ns, cx, cy, anim) {
    var s = S(img); ns = Math.max(MIN, Math.min(MAX, ns));
    var r = img.getBoundingClientRect();
    var px = cx - (r.left - s.x), py = cy - (r.top - s.y);
    s.x = px - (px - s.x) * (ns / s.s);
    s.y = py - (py - s.y) * (ns / s.s);
    s.s = ns; if (ns === 1) { s.x = 0; s.y = 0; }
    apply(img, anim);
  }
  function reset(img) { var s = S(img); s.s = 1; s.x = 0; s.y = 0; apply(img, false); }
  function imgFrom(t) { var stage = t && t.closest && t.closest('.lightbox__stage'); return stage ? stage.querySelector('img') : null; }

  // Trackpad pinch (Chrome/Edge/Firefox send ctrl+wheel) and mouse wheel
  document.addEventListener('wheel', function (e) {
    var img = imgFrom(e.target); if (!img) return;
    var s = S(img);
    if (e.ctrlKey) {
      e.preventDefault();
      zoomAt(img, s.s * Math.exp(-e.deltaY * 0.012), e.clientX, e.clientY, false);
    } else if (s.s > 1) {
      e.preventDefault();
      s.x -= e.deltaX; s.y -= e.deltaY; apply(img, false);
    }
  }, { passive: false });

  // Safari desktop trackpad pinch
  var gBase = 1;
  document.addEventListener('gesturestart', function (e) { var img = imgFrom(e.target); if (!img) return; e.preventDefault(); gBase = S(img).s; }, { passive: false });
  document.addEventListener('gesturechange', function (e) { var img = imgFrom(e.target); if (!img) return; e.preventDefault(); zoomAt(img, gBase * e.scale, e.clientX, e.clientY, false); }, { passive: false });
  document.addEventListener('gestureend', function (e) { if (imgFrom(e.target)) e.preventDefault(); }, { passive: false });

  // Double-click / double-tap to zoom in and out
  document.addEventListener('dblclick', function (e) {
    var img = imgFrom(e.target); if (!img) return;
    e.preventDefault();
    var s = S(img); zoomAt(img, s.s > 1 ? 1 : STEP, e.clientX, e.clientY, true);
  });

  // Drag to pan (mouse) and two-finger pinch (touch screens)
  var pts = new Map(), drag = null, pinch = null;
  document.addEventListener('pointerdown', function (e) {
    var img = imgFrom(e.target); if (!img) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 2) {
      var a = Array.from(pts.values());
      pinch = { img: img, d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), s: S(img).s };
      drag = null;
    } else if (S(img).s > 1) {
      drag = { img: img, x: e.clientX, y: e.clientY }; img.style.cursor = 'grabbing';
      e.preventDefault();
    }
  });
  document.addEventListener('pointermove', function (e) {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pinch && pts.size === 2) {
      var a = Array.from(pts.values());
      var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
      zoomAt(pinch.img, pinch.s * d / pinch.d, (a[0].x + a[1].x) / 2, (a[0].y + a[1].y) / 2, false);
      e.preventDefault();
    } else if (drag) {
      var s = S(drag.img); s.x += e.clientX - drag.x; s.y += e.clientY - drag.y;
      drag.x = e.clientX; drag.y = e.clientY; apply(drag.img, false); e.preventDefault();
    }
  }, { passive: false });
  function up(e) { pts.delete(e.pointerId); if (pts.size < 2) pinch = null; if (drag) { apply(drag.img, false); drag = null; } }
  document.addEventListener('pointerup', up); document.addEventListener('pointercancel', up);

  // Stop a click after dragging from closing the lightbox / changing image
  document.addEventListener('click', function (e) { var img = imgFrom(e.target); if (img && S(img).s > 1) { e.stopPropagation(); e.preventDefault(); } }, true);

  // Reset zoom whenever the image changes or the lightbox closes
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var t = m.target;
      if (t.tagName === 'IMG' && t.closest && t.closest('.lightbox__stage') && m.attributeName === 'src') reset(t);
    });
    document.querySelectorAll('.lightbox__stage img').forEach(function (img) { if (!img.offsetParent && S(img).s !== 1) reset(img); });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['src', 'class', 'style', 'open', 'hidden', 'aria-hidden'] });

  var css = document.createElement('style');
  css.textContent = '.lightbox__stage{overflow:hidden;touch-action:none}.lightbox__stage img{cursor:zoom-in;will-change:transform;user-select:none;-webkit-user-drag:none}' +
    '.lightbox__picture::after{content:"Pinch or double-click to zoom";display:block;text-align:center;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#3a2a20;font-weight:600;margin:10px 0 0}' +
    '@media (hover:none){.lightbox__picture::after{content:"Pinch or double-tap to zoom"}}';
  document.head.appendChild(css);
})();
